import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
    document.addEventListener("click", this.closeOnOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
  }

  closeOnOutside(event) {
    if (!this.element.open) return
    if (this.element.contains(event.target)) return

    this.element.open = false
  }
}
